<template>
  <div class="flex flex-col" :class="{ 'is-dragging': draggedIndex !== null }">
    <div
      v-for="(item, index) in items"
      :key="item.uuid"
      class="flex items-center text-sm border-l-2 border-transparent transition-colors select-none"
      :class="rowClass(index)"
      @dragover.prevent="onDragOver(index)"
      @dragleave="onDragLeave"
      @drop.prevent="onDrop(index)"
    >
      <span
        class="drag-handle material-symbols-outlined shrink-0 pl-4 pr-1 text-gray-400 hover:text-gray-600"
        style="font-size: 1.15rem"
        draggable="true"
        title="Drag to reorder"
        @dragstart.stop="onDragStart(index)"
        @dragend="onDragEnd"
      >drag_indicator</span>

      <Link
        :href="pageHref(item)"
        class="flex-1 truncate py-2.5 pr-2 min-w-0 hover:text-main cursor-pointer select-text"
        :class="{ 'font-semibold text-main': activeUuid === item.uuid }"
      >
        {{ item.name }}
      </Link>

      <Link
        v-if="removable && activeUuid === item.uuid"
        :href="removeHref(item)"
        class="pr-4 opacity-40 hover:opacity-100 shrink-0"
        title="Remove"
        @click.stop
      >
        <i class="fa-solid fa-trash"></i>
      </Link>
      <span v-else-if="removable" class="pr-4 w-6 shrink-0" />
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import axios from 'axios'

export default {
  components: { Link },
  props: {
    items: { type: Array, required: true },
    siteUuid: { type: String, required: true },
    activeUuid: { type: String, default: null },
    zone: { type: String, required: true },
    orderEndpoint: { type: String, required: true },
    removable: { type: Boolean, default: false },
  },
  emits: ['reorder'],
  data() {
    return {
      draggedIndex: null,
      dragOverIndex: null,
    }
  },
  methods: {
    pageHref(item) {
      return `/site/${this.siteUuid}/page/${item.uuid}`
    },
    removeHref(item) {
      return `/site/${this.siteUuid}/page/${item.uuid}/remove/portfolio`
    },
    rowClass(index) {
      const active = this.activeUuid === this.items[index]?.uuid
      return {
        'bg-bay': active,
        'opacity-50': this.draggedIndex === index,
        'bg-bay border-main': this.dragOverIndex === index && this.draggedIndex !== null,
      }
    },
    onDragStart(index) {
      this.draggedIndex = index
    },
    onDragEnd() {
      this.draggedIndex = null
      this.dragOverIndex = null
    },
    onDragOver(index) {
      if (this.draggedIndex !== null) {
        this.dragOverIndex = index
      }
    },
    onDragLeave() {
      this.dragOverIndex = null
    },
    onDrop(dropIndex) {
      const dragIndex = this.draggedIndex
      if (dragIndex === null || dragIndex === dropIndex) {
        this.onDragEnd()
        return
      }

      const next = [...this.items]
      const [moved] = next.splice(dragIndex, 1)
      next.splice(dropIndex, 0, moved)

      this.$emit('reorder', next)
      this.persistOrder(next)
      this.onDragEnd()
    },
    persistOrder(items) {
      axios
        .post(this.orderEndpoint, { newOrder: items.map(item => item.uuid) })
        .catch(error => {
          console.error(`Failed to update ${this.zone} order:`, error)
        })
    },
  },
}
</script>

<style scoped>
.drag-handle {
  cursor: grab;
  user-select: none;
}

.drag-handle:active,
.is-dragging .drag-handle {
  cursor: grabbing;
}

.is-dragging {
  cursor: grabbing;
}
</style>
